import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  ButtonGroup,
  Button,
  Row,
  Col,
  Dropdown,
  Checkbox,
  List,
  Modal,
  ControlLabel,
  Input,
  SelectPicker,
  DatePicker,
  Uploader,
  Drawer,
  InputGroup,
  CheckboxGroup,
  Container,
} from 'rsuite'
import { initialNewData, getExpandedId, getNewDataEdit } from './SubprojectExpenseRecordUntils'
import EditSelectCell from '../../components/cell/EditSelectCell'
import EditTextCell from '../../components/cell/EditTextCell'
import EditNumberCell from '../../components/cell/EditNumberCell'
import TooltipButton from '../../components/buttons/TooltipButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { budgetFormat } from '../../utils/formatterUtil'
import {
  isImageOrPdf,
  isRequired,
  isValidators,
  requiredFiled,
  getMaxLengthData,
  hasMinValidator,
} from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import moment from 'moment/moment'
import { LOCAL_DAY_TH } from '../../constants/date'
import { cloneDeep } from 'lodash-es'
import { v4 as uuidv4 } from 'uuid'

export default function SubprojectExpenseRecordTable({
  schema,
  loading,
  isEnableEdit,
  onChangeTableData = () => {},
  register,
  errors,
  control,
  setError,
  setValue,
  getValues,
  clearErrors,
  isViewMode,
  ...props
}) {
  // const { register, handleSubmit, errors, control, setError, clearErrors } = useForm()
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])

  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [showModalDurableArticles, setShowModalDurableArticles] = useState(false)
  const [expenseTypeVal, setExpenseTypeVal] = useState(null)
  const [showModalExpenseFor, setShowModalExpenseFor] = useState(false)
  const [checkBoxList, setCheckBoxList] = useState([])

  const _styleCellSummary = { backgroundColor: '#1f5581', color: '#fff', fontWeight: 'bold' }

  useEffect(() => {
    console.log('gggg')
    setTableData(schema.values)
    register('table', schema.values || [])
    setValue('table', schema.values || [])
  }, [schema.values])

  const handleOpenEditRow = (rowData) => {
    tableData.map((row) => {
      if (row.id == rowData.id) {
        const nextData = getNewDataEdit(tableData, row)
        setTableData(nextData)
      }
    })
  }

  const onDeleteRow = (rowData) => {
    let datas = cloneDeep(tableData)

    datas = datas.filter((e) => e.id != rowData.id)

    var sumObj = {}
    if (datas && datas?.length > 0) {
      sumObj = datas[datas.length - 1]

      sumObj.amount = 0
      sumObj.withholding = 0
      sumObj.receivedAmount = 0

      datas?.splice(-1)
    } else {
      datas = []

      sumObj = {
        id: '',
        expenseList: '',
        expenseTotal: 0,
        isRowTotal: true,
      }
    }

    datas.forEach((e) => {
      sumObj.amount = sumObj.amount + e.amount
      sumObj.withholding = sumObj.withholding + e.withholding
      sumObj.receivedAmount = sumObj.receivedAmount + e.receivedAmount
    })

    datas.push(sumObj)

    setTableData(datas)
    setValue('table', datas)
    // onDelete(datas)
  }

  const handleOnClickAddNewData = () => {
    // setTableData()
    let datas = cloneDeep(tableData)

    //var lasted = datas[datas.length-1]
    var runnigNum = 1
    var sumObj = {}
    if (datas && datas?.length > 0) {
      runnigNum = datas.length - 1
      sumObj = datas[datas.length - 1]

      sumObj.amount = 0
      sumObj.withholding = 0
      sumObj.receivedAmount = 0

      datas?.splice(-1)
    } else {
      datas = []

      sumObj = {
        id: '',
        expenseList: '',
        expenseTotal: 0,
        isRowTotal: true,
      }
    }

    var newObj = {
      id: 'addNew-' + runnigNum + '-' + uuidv4(),
      expenseList: '',
      expenseTotal: 0,
      isDeletable: true,
      status: 'EDIT',
    }

    datas.push(newObj)

    datas.forEach((e) => {
      sumObj.amount = sumObj.amount + e.amount
      sumObj.withholding = sumObj.withholding + e.withholding
      sumObj.receivedAmount = sumObj.receivedAmount + e.receivedAmount
    })

    datas.push(sumObj)

    // console.log('datas : ', datas)

    setTableData(datas)
  }

  const onChangeTableValue = (index, value, key) => {
    let datas = cloneDeep(tableData)
    datas[index].expenseTotal = value || 0

    setTableData(datas)
    setValue('table', datas)
  }

  const getTotalSummary = (_tableData) => {
    return _tableData.reduce((pre, cur) => {
      if (cur.expenseTotal && !cur.isSummary) {
        return pre + cur.expenseTotal
      }
      return pre
    }, 0)
  }

  return (
    <>
      <Table wordWrap autoHeight loading={loading} data={tableData} style={{ marginTop: '20px' }}>
        <Column width={120} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(rowData, index) => {
              if (rowData.isSummary) {
                return ''
              }

              return index + 1
            }}
          </Cell>
        </Column>

        <Column width={200} flexGrow={1}>
          <HeaderCell>จ่ายให้กิจกรรม</HeaderCell>
          <Cell>
            {(rowData, index) => {
              if (rowData.isSummary) {
                return <b>{rowData.expenseList}</b>
              }

              return (
                <EditTextCell
                  id={`${schema.expenseList.name}_${index + 1 || rowData.makeId}`}
                  // id={`table[${index}].${schema.expenseList.name}`}
                  rowSchema={schema.expenseList}
                  rowData={rowData}
                  dataKey={schema.expenseList.name}
                  register={register}
                  control={control}
                  errors={errors}
                  required={!rowData.expenseList && { required: false }}
                />
              )
            }}
          </Cell>
        </Column>

        <Column width={200} flexGrow={1}>
          <HeaderCell>รายการ</HeaderCell>
          <Cell>
            {(rowData, index) => {
              if (rowData.isSummary) {
                return <b>{rowData.expenseType}</b>
              }

              return (
                <EditTextCell
                  id={`${schema.expenseType.name}_${index + 1 || rowData.makeId}`}
                  // id={`table[${index}].${schema.expenseType.name}`}
                  rowSchema={schema.expenseType}
                  rowData={rowData}
                  dataKey={schema.expenseType.name}
                  register={register}
                  control={control}
                  errors={errors}
                  isRequired={true}
                  isBudgetFormat={true}
                  styleSheet={{ marginTop: 8, textAlign: 'right' }}
                />
              )
            }}
          </Cell>
        </Column>

        <Column width={120}>
          <HeaderCell>ยอดรวม</HeaderCell>
          <Cell align="right">
            {(rowData, index) => {
              if (rowData.isSummary) {
                // return <b>{budgetFormat(rowData.expenseTotal)}</b>
                console.log('rowData.expenseTotal ', rowData.expenseTotal)
                return (
                  <span className={'cost-total-summary'}>
                    {`${budgetFormat(getTotalSummary(tableData))}`}
                  </span>
                )
              }

              return (
                <EditNumberCell
                  id={`${schema.expenseTotal.name}_${index + 1 || rowData.makeId}`}
                  // id={`table[${index}].${schema.expenseTotal.name}`}
                  rowData={rowData}
                  dataKey={schema.expenseTotal.name}
                  register={register}
                  control={control}
                  errors={errors}
                  // isRequired={true}
                  isBudgetFormat={true}
                  styleSheet={{ marginTop: 8, textAlign: 'right' }}
                  onChangeCell={(value) => {
                    onChangeTableValue(index, value)
                  }}
                  allowNegative={!hasMinValidator(schema.expenseTotal.validators)}
                />
              )
            }}
          </Cell>
        </Column>

        {!isViewMode && (
          <Column width={180} align="center" fixed="right">
            <HeaderCell>จัดการรายการ</HeaderCell>
            {/* <CellMagButton key="id" /> */}
            <Cell align="center">
              {(rowData) => {
                if (rowData.isSummary) {
                  return ''
                }

                return (
                  <>
                    {rowData.id?.indexOf('addNew') == -1 && (
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-edit"
                        icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                        onClick={() => handleOpenEditRow(rowData)}
                        size="sm"
                      >
                        แก้ไข
                      </IconButton>
                    )}

                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-cancel"
                      icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                      onClick={() => {
                        onDeleteRow(rowData)
                      }}
                      size="sm"
                      style={{ marginLeft: 5 }}
                    >
                      ลบ
                    </IconButton>
                  </>
                )
              }}
            </Cell>
          </Column>
        )}
      </Table>

      {!isViewMode && (
        <div style={{ marginTop: 10 }}>
          <Row>
            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <IconButton
                appearance="ghost"
                icon={<Icon icon="plus" className="bt-gost-icon-radius" />}
                onClick={handleOnClickAddNewData}
                // disabled={disabledButton}
                style={{ marginLeft: 5 }}
              >
                {'เพิ่มรายการ'}
              </IconButton>
            </Col>
          </Row>
        </div>
      )}

      <ConfirmWidget
        title={`ยืนยันการลบงวดเงิน`}
        show={isShowConfirmDelete}
        detail={`กรุณายืนยันการลบงวดเงิน`}
        onCancle={() => setIsShowConfirmDelete(false)}
        // onConfirm={handleOnConfirmDelete}
      />

      {/* <>
        <div>
          <br />
          <Row>
            <Col lg={12} md={12} sm={24} xs={24}>
              <Button color="red" appearance="link">
                <Icon icon="trash" size="lg" /> ลบเอกสาร
              </Button>
            </Col>
            <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <Button color="blue" appearance="link">
                <Icon icon="search" size="lg" /> ใบสำคัญจ่าย
              </Button>
              <Button
                appearance="subtle"
                style={{ marginLeft: 3, marginRight: 3, backgroundColor: '#ccc', color: '#fff' }}
              >
                <Icon icon="close-circle" size="lg" /> ยกเลิก
              </Button>
              <Button color="blue" appearance="primary">
                <Icon icon="check-circle" size="lg" /> บันทึก
              </Button>
            </Col>
          </Row>
        </div>
      </> */}
      {/* )} */}
    </>
  )
}
